import { Link } from 'react-router-dom';

const LINE_URL = 'https://lin.ee/PNbhQI0';
const INSTAGRAM_URL = 'https://www.instagram.com/enmusubi.wahaha?igsh=eWxjM2d1eDA5N3Nv&utm_source=qr';
const FACEBOOK_URL = 'https://www.facebook.com/share/1NsTgMVW1J/?mibextid=wwXIfr';

export default function Footer() {
  return (
    <footer style={{ background: '#4a3728' }} className="px-4 pt-8 pb-5 md:pt-10 md:pb-6">
      <div className="content-width">
        {/* Footer Links */}
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 md:gap-x-5 md:gap-y-3 mb-6 md:mb-8">
          {[
            { label: 'トップ', path: '/' },
            { label: 'ご挨拶', path: '/greeting' },
            { label: '活動の流れ', path: '/service' },
            { label: 'ご入会の流れ', path: '/enrollment' },
            { label: '選ばれる理由', path: '/reason' },
            { label: '成婚事例', path: '/success' },
            { label: '料金プラン', path: '/price' },
            { label: 'よくある質問', path: '/faq' },
            { label: 'ブログ', path: '/blog' },
            { label: 'お問い合わせ', path: '/contact' },
            { label: 'プライバシーポリシー', path: '/privacy' },
          ].map((item) => (
            <Link
              key={item.path}
              to={item.path}
              style={{ color: 'rgba(255,255,255,0.7)', fontSize: '13px' }}
              className="hover:text-white transition-colors whitespace-nowrap"
            >
              {item.label}
            </Link>
          ))}
        </div>

        {/* Contact Info */}
        <div className="flex flex-col items-center gap-3 md:gap-4 mb-6 md:mb-8">
          <a
            href="tel:03-4500-8399"
            style={{ color: 'rgba(255,255,255,0.9)', fontSize: 'clamp(17px, 3vw, 20px)', fontWeight: '700' }}
            className="flex items-center gap-2 hover:text-white"
          >
            <span className="flex items-center justify-center w-7 h-7 md:w-8 md:h-8">
              <i className="ri-phone-line text-[#e8934e] text-lg md:text-xl"></i>
            </span>
            03-4500-8399
          </a>
          <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px' }}>
            受付時間 10:00〜18:00
          </span>
          <a
            href={LINE_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            style={{ background: '#06C755', color: '#fff', borderRadius: '8px', padding: '9px 20px', fontSize: '14px', fontWeight: '700' }}
            className="flex items-center gap-2 hover:opacity-90 transition-opacity whitespace-nowrap"
          >
            <span className="flex items-center justify-center w-5 h-5">
              <i className="ri-line-fill text-lg"></i>
            </span>
            LINE相談
          </a>

          {/* SNS Links */}
          <div className="flex items-center gap-4 mt-1">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-2 hover:opacity-80 transition-opacity whitespace-nowrap"
              style={{ color: 'rgba(255,255,255,0.85)', fontSize: '14px' }}
            >
              <span className="flex items-center justify-center w-8 h-8 rounded-full" style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}>
                <i className="ri-instagram-line text-white text-base"></i>
              </span>
              Instagram
            </a>
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-2 hover:opacity-80 transition-opacity whitespace-nowrap"
              style={{ color: 'rgba(255,255,255,0.85)', fontSize: '14px' }}
            >
              <span className="flex items-center justify-center w-8 h-8 rounded-full" style={{ background: '#1877F2' }}>
                <i className="ri-facebook-fill text-white text-base"></i>
              </span>
              Facebook
            </a>
          </div>
        </div>

        {/* Copyright */}
        <p
          className="text-center"
          style={{ color: 'rgba(255,255,255,0.7)', fontSize: '12px' }}
        >
          © 縁結び 和はは All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
